import { render, staticRenderFns } from "./carddevelopment.vue?vue&type=template&id=5047d798&scoped=true&"
import script from "./carddevelopment.vue?vue&type=script&lang=js&"
export * from "./carddevelopment.vue?vue&type=script&lang=js&"
import style0 from "./carddevelopment.vue?vue&type=style&index=0&id=5047d798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047d798",
  null
  
)

export default component.exports